import { MaritalStatus } from '@axo/shared/data-access/types';
import { Broker } from '@axo/shared/data-access/types/broker';
import { MarketCountryCode } from '@axo/shared/types';
import { useApplicationConditionalFilter } from '../../../../ConditionalWrappers/useApplicationConditionalFilter';
import { UnfilteredConditionalArray } from '../../../../ConditionalWrappers/types';
import { ApplicationConditionalContext } from '../../../../ConditionalWrappers/useApplicationConditionalContext';

const unfilteredMaritalStatusOptions = (
  [
    { value: null },
    { value: MaritalStatus.Married },
    { value: MaritalStatus.Single },
    { value: MaritalStatus.Cohabiting },
    {
      value: MaritalStatus.Seperated,
      whitelist: [
        { marketCountry: [MarketCountryCode.Sweden], broker: [Broker.Zmarta] },
      ],
    },
    {
      value: MaritalStatus.Widowed,
      whitelist: [
        { marketCountry: [MarketCountryCode.Sweden], broker: [Broker.Zmarta] },
      ],
    },
  ] satisfies UnfilteredConditionalArray<
    ApplicationConditionalContext,
    MaritalStatus | null
  >
).map(({ value, ...rest }) => ({
  value: { value, label: value ? value : '-' },
  ...rest,
}));

export const useMaritalStatusOptions = () =>
  useApplicationConditionalFilter(unfilteredMaritalStatusOptions);
